import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../core/table/table.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { HighlightPipe } from '../../../../pipes/highlight.pipe';
import { ExpandPanelComponent } from '../../../core/panels/expand-panel.component';
import {
  getExpandDateOnly,
  getExpandSubject,
} from '../../../../functions/get-expand-subject';

@Component({
  selector: 'app-case-note',
  imports: [
    TableComponent,
    ColumnComponent,
    HighlightPipe,
    ExpandPanelComponent,
  ],
  template: ` <app-table
    #noteTable
    [dataSource]="dataSource"
    [scrollable]="false"
    recordLabel="Case Note"
  >
    <app-column label="Category" name="category" width="12" />
    <app-column label="Subject" name="subject" width="12" />
    <app-column label="Service" name="service" width="5" />
    <app-column label="Created Date" name="createdDate" width="12" format="d" />
    <app-column
      label="Completed Date"
      name="completedDate"
      width="12"
      format="d"
    />
    <app-column label="Completed By" name="completedBy" width="12" />
    <app-column label="Sent Date" name="sentDate" format="d" width="12" />
    <app-column label="Last Updated By" name="lastUpdatedBy" width="12" />
    <app-column name="note" [fullRow]="true" [fullRowLabel]="false">
      <ng-template #item let-row>
        <app-expand-panel
          [expanded]="noteTable.expanded"
          [label]="
            getExpandSubject(
              row.subject,
              row.category,
              getExpandDateOnly(row.createdDate)
            ) || 'Case note'
          "
          collapseHeight="114px"
        >
          <span
            style="white-space: pre-line;"
            [innerHTML]="row.note | highlight: noteTable.searchValue"
          ></span>
        </app-expand-panel>
      </ng-template>
    </app-column>
  </app-table>`,
  styles: [``],
})
export class CaseNoteComponent {
  @Input() dataSource: any;

  protected getExpandSubject = getExpandSubject;
  protected getExpandDateOnly = getExpandDateOnly;
}
